(function() {
	'use strict';
	var $ = avm.require('cash'),
		waypoints = avm.require('avast.web.waypoints'),
		$window = $(window),
		$graph = $('.js-graph'),
		yt_url = $('#ytPlayer').attr('src'),
		$btnCollapse = $('.cmp-collapse.btn');

	// Cooperation with Collapse element so head is also controlled
	$btnCollapse.on('click', function () {
		var $head = $(this).parent().siblings('.collapse-head'),
			$body = $(this).parent().siblings('.collapse-body');

		if ($body.attr('aria-expanded') == 'false') {

			$head.removeClass('show');
			$head.attr('aria-expanded', 'false');
			window.scrollTo(0, $(this).parent().parent().offset().top-100);

		} else if ($body.attr('aria-expanded') == 'true') {

			$head.addClass('show');
			$head.attr('aria-expanded', 'true');
		}
	});



	// Animated graph section
	$window.on('resize scroll', function() {
		if (waypoints($graph, null, $window.height() - 100)) {
			$graph.addClass('animate');
		}
	});

	// Opening Modal with video
	$('.btn-video .btn-link').on('click', function () {
		if ($('#ytPlayer').attr('src') == yt_url) {

		} else {
			$('#ytPlayer').attr('src', yt_url);
		}
	});

	// Closing modal
	$('.close').on('click', function () {
		$('#ytPlayer').attr('src', '');
	});

	$("#modal-ytVideo").on('click', function (e) {
		if (!$(e.target).hasClass('modal-content')) {
			$('#ytPlayer').attr('src', '');
		}
	})

})();
